// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1p6RS","content":"GlobalSearch_content__1tdg4"};